var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3985 14.3586C15.6535 13.0934 16.4287 11.3517 16.4287 9.42896C16.4287 5.56296 13.2947 2.42896 9.42871 2.42896C5.56272 2.42896 2.42871 5.56296 2.42871 9.42896C2.42871 13.2949 5.56272 16.429 9.42871 16.429C11.3515 16.429 13.0932 15.6537 14.3583 14.3988L14.3985 14.3586ZM16.4606 15.0467C17.6922 13.507 18.4287 11.554 18.4287 9.42896C18.4287 4.45839 14.3993 0.428955 9.42871 0.428955C4.45815 0.428955 0.428711 4.45839 0.428711 9.42896C0.428711 14.3995 4.45815 18.429 9.42871 18.429C11.5537 18.429 13.5067 17.6925 15.0463 16.4609L22.1565 23.5711L23.5708 22.1569L16.4606 15.0467ZM8.42871 10.429V13.429H10.4287V10.429H13.4287V8.42896H10.4287V5.42896H8.42871V8.42895H5.42871V10.429H8.42871Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.a45ada3ba1e13dd207af212037a487f9.svg";
export { ForwardRef as ReactComponent };